import { useEffect } from 'react';

/**
 * Closes an overlay when the user presses Escape.
 *
 * Every modal in the app should call this (or render through {@link Dialog})
 * so Escape is a reliable way out, matching backdrop click and close buttons.
 */
export function useEscapeToClose(onClose: () => void): void {
  useEffect(() => {
    function onKey(event: KeyboardEvent) {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
}
